import { ReadOnlyField } from '@app/components/various/Fields/ReadOnlyField';
import { FieldLabel } from '@app/components/various/Form';
import { getCheckoutFields } from '@app/ducks';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

interface Props {
  preferredShippingDate: string | boolean;
  cancelDate: string | boolean;
}

export const CheckoutSuccessShippingPreferences = ({ preferredShippingDate, cancelDate }: Props) => {
  const { t } = useTranslation(['checkout', 'shipping']);
  const checkoutFields = useSelector(getCheckoutFields);

  const shouldShowShippingPreferences = 'preferredShippingDate' in checkoutFields || 'preferredShippingDateBySplitOrder' in checkoutFields;
  const shouldShowCancelDate = 'cancelDate' in checkoutFields || 'cancelDateBySplitOrder' in checkoutFields;

  if (!shouldShowShippingPreferences && !shouldShowCancelDate) {
    return null;
  }

  const shippingDateValue = typeof preferredShippingDate === 'string' ? preferredShippingDate : '-';
  const cancelDateValue = typeof cancelDate === 'string' ? cancelDate : '-';

  return (
    <div className="box">
      <h3 className="mb-5 heading-3">{t('checkout:shipping_preferences')}</h3>
      <div className="grid grid-cols-1 gap-5 has-[>:only-child]:grid-cols-1 md:grid-cols-2">
        <FieldLabel as="div" label={t('shipping:preferred_shipping_date')}>
          <ReadOnlyField>{shippingDateValue}</ReadOnlyField>
        </FieldLabel>
        <FieldLabel as="div" label={t('checkout:cancel_date')}>
          <ReadOnlyField>{cancelDateValue}</ReadOnlyField>
        </FieldLabel>
      </div>
    </div>
  );
};
